import { render } from "./TheTaskIndexPage.vue?vue&type=template&id=ac0d79c0"
import script from "./TheTaskIndexPage.vue?vue&type=script&lang=js"
export * from "./TheTaskIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__